const NAME = "CAT_AND_SPEC_SETTINGS";

export default NAME;
